import React, { useState, useContext, useRef, useEffect } from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"
import Link from "gatsby-link"
import { ThemeContext } from "styled-components"
import { motion } from "framer-motion"
import Container from "../container"
import { UserContext } from "../global-context"
import { LoadedContext } from "../loaded-context"

import PreloadImages from "./preload-images"
import Menu from "./menu"

// import TimeZones from "../time-zones"

import TimeZonesContainer from "./timezones"

import TimeZonesInfo from "./static-info"

import { ReactComponent as BurgerIcon } from "../../assets/images/burger-icon.svg"
import { ReactComponent as CloseIcon } from "../../assets/images/burger-close.svg"
import { ReactComponent as NavLogo } from "../../assets/images/supercontinental-logo.svg"

// import LogoSpacer from "../logo-spacer"

const StyledBurgerIcon = styled(BurgerIcon)`
  opacity: 1;
  width: 100%;
  left: 0;

  ${props =>
    props.open &&
    css`
      opacity: 0;
    `}
`

const StyledCloseIcon = styled(CloseIcon)`
  opacity: 0;
  width: 60%;
  left: 20%;

  ${props =>
    props.open &&
    css`
      opacity: 1;
    `}
`

const Burger = styled.button`
  position: absolute;
  right: 5.2%;
  top: 100%;
  margin-top: ${rem(10)};
  background: none;
  opacity: 1;
  padding: 0;
  appearance: none;
  border: 0;
  cursor: pointer;
  width: 3%;
  color: #ff2300;

  @media ${props => props.theme.desktopDown} and ${props =>
  props.theme.mobileUp} {
    width: 5.5%;
    right: 5.2%;
    margin-top: ${rem(6)};
  }

  @media ${props => props.theme.mobileDown} {
    width: 12.5%;
    width: ${rem(40)};
    right: ${rem(20)};
    margin-top: ${rem(2)};
  }

  &:focus {
    outline: none;
  }

  svg {
    position: absolute;
  }
`

const NavEl = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;

  @media ${props => props.theme.mobileUp} {
    padding-top: ${rem(15)};
    padding-bottom: ${rem(15)};
  }

  @media ${props => props.theme.mobileDown} {
    padding-top: ${rem(15)};
    padding-bottom: ${rem(15)};
  }
`

const Logo = styled.div`
  opacity: 0;
  margin: 0 auto;

  ${props =>
    props.loaded &&
    css`
      opacity: 1;
    `}

  a {
    display: block;
    width: 100%;
  }

  svg {
    display: block;
    width: 100%;
    margin: 0 auto;
  }
`

const StyledLink = styled(Link)`
  svg {
    transition: color 0.5s, width 0.5s;
  }

  ${props =>
    props.logocolor &&
    css`
      color: ${props => props.logocolor};
    `}
`

let prevValue = null

const Nav = props => {
  const [isOpen, setMenuOpen] = useState(false)
  const [timesVisible, setTimesVisible] = useState(false)

  const globalContext = useContext(UserContext)
  const themeContext = useContext(ThemeContext)
  const loadedContext = useContext(LoadedContext)

  const logoRef = useRef(null)
  const burgerRef = useRef(null)

  const navScroll = () => {
    let defaultZoom = 100

    let targetZoom = 35

    let maxScrollTop = 250

    const burgerDefaultTop = 100
    const burgerTargetTop = 4

    // let scrollRatio = 1 - window.scrollY / maxScrollTop

    let scrollPercentage = Math.min(1, window.scrollY / maxScrollTop)

    // calculation: initial - (initial - target) * scrollPercentage

    let logoWidth = defaultZoom - (defaultZoom - targetZoom) * scrollPercentage

    let burgerTop =
      burgerDefaultTop - (burgerDefaultTop - burgerTargetTop) * scrollPercentage

    // console.log('logoWidth: ', defaultZoom - (defaultZoom - targetZoom) * scrollPercentage )

    logoRef.current.style.width = logoWidth + "%"
    // console.log('burga top: ', burgerTop)

    burgerRef.current.style.top = burgerTop + "%"

    // const targetLogoWidth = 50 * scrollRatio

    window.scrollY > maxScrollTop
      ? setTimesVisible(true)
      : setTimesVisible(false)
  }

  // console.log('timezones: ', TimeZones() )

  useEffect(() => {
    const isMobile = () => matchMedia(themeContext.mobileDown).matches

    if (!isMobile()) {
      window.addEventListener("scroll", navScroll)
    }

    return () => {
      window.removeEventListener("scroll", navScroll)
    }
  }, [themeContext.mobileDown])

  const toggleMenu = () => {
    setMenuOpen(!isOpen)

    //
    if (!isOpen) {
      prevValue = globalContext.value
    }

    isOpen
      ? globalContext.setValue(prevValue)
      : globalContext.setValue("#c6c5c6")
  }

  return (
    <React.Fragment>
      <NavEl>
        <TimeZonesContainer
          color={globalContext.value}
          timesVisible={timesVisible}
        />

        <Container>
          <Logo ref={logoRef} loaded={loadedContext.loaded}>
            <StyledLink
              onClick={() => {
                isOpen && toggleMenu()
              }}
              logocolor={globalContext.value}
              to="/"
              aria-label="Home"
            >
              <NavLogo color={globalContext.value} />
            </StyledLink>
          </Logo>

          <Menu isOpen={isOpen} toggleMenu={toggleMenu} />

          <Burger
            ref={burgerRef}
            onClick={() => {
              toggleMenu()
            }}
            aria-label={`${isOpen ? "Close" : "Open"} menu`}
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={loadedContext.loaded && { opacity: 1 }}
            >
              <StyledBurgerIcon open={isOpen} />
              <StyledCloseIcon open={isOpen} />
            </motion.div>
          </Burger>
        </Container>
      </NavEl>

      <TimeZonesInfo />

      <PreloadImages />
    </React.Fragment>
  )
}

export default Nav
